import {
    CONDITIONS_GENERALES_ALL,
    CONDITIONS_GENERALES_ERROR,
    CONDITIONS_GENERALES_SUCCESS
} from "../actions/conditions_generales";

const initialState = {
    all: [],
    data: {},
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === CONDITIONS_GENERALES_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === CONDITIONS_GENERALES_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    } else if (action.type === CONDITIONS_GENERALES_ALL) {
        return Object.assign({}, state, {
            all: action.data,
            error: null
        });
    }
    return state;
}